module.exports = __webpack_public_path__ + "img/4dbe971.png";